export type Money = {
    amount: number;
    currency: string;
};

export const isOfTypeMoney = (
    toBeDetermined: unknown
): toBeDetermined is Money => {
    return (
        (toBeDetermined as Money)?.amount !== undefined &&
        (toBeDetermined as Money)?.currency !== undefined
    );
};
